import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  "data-cy": "ClientCompanies-name",
  class: "d-flex align-center primary--text"
}
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = {
  "data-cy": "ClientCompanies-name",
  class: "d-flex align-center primary--text"
}
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = { class: "d-flex align-center primary--text" }
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { class: "d-flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ClientCompaniesEditCompanyBtn = _resolveComponent("ClientCompaniesEditCompanyBtn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_company_table = _resolveComponent("company-table")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_EditCompany = _resolveComponent("EditCompany")!
  const _component_CompaniesImport = _resolveComponent("CompaniesImport")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pb-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "my-3 justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_primary, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogSelectCompany = !_ctx.dialogSelectCompany)),
                block: "",
                "data-cy": "ClientCompanies-add"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("shared.add")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.enableWrite)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.accountingFirm.clientUserAccessRight,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accountingFirm.clientUserAccessRight) = $event)),
                    items: _ctx.clientUserAccessRights,
                    "item-value": "id",
                    label: "Mode d'accès",
                    "hide-details": "auto",
                    "data-cy": "ClientCompanies-modeAcces",
                    density: "compact",
                    "item-title": "name"
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.enableWrite)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.archivedClientCompaniesMode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.archivedClientCompaniesMode) = $event)),
                    items: _ctx.archivedClientCompaniesOptions,
                    "item-value": "id",
                    label: "Type de dossiers",
                    "hide-details": "auto",
                    "data-cy": "ClientCompanies-modeAcces",
                    density: "compact",
                    "item-title": "name"
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: _ctx.selectedAccontingType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedAccontingType) = $event)),
                items: _ctx.accountingTypes,
                label: "Comptabilité",
                "hide-details": "",
                elevation: "0",
                "data-cy": "ClientCompanies-comptabilite",
                density: "compact",
                "item-title": "text",
                clearable: ""
              }, null, 8, ["modelValue", "items"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_autocomplete, {
                class: "custom-autocomplete",
                modelValue: _ctx.selectedLegalForm,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedLegalForm) = $event)),
                items: _ctx.legalForms,
                "item-title": _ctx.formatItemTitle,
                "item-value": "id",
                label: "Type de société",
                "data-cy": "ClientCompanies-societe",
                clearable: ""
              }, null, 8, ["modelValue", "items", "item-title"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event)),
                label: "Recherche",
                outlined: "",
                "hide-details": "",
                "data-cy": "ClientCompanies-search",
                density: "compact",
                "append-inner-icon": "$search",
                clearable: "",
                "onClick:clear": _cache[6] || (_cache[6] = ($event: any) => (_ctx.search = ''))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "1",
            class: "align-center d-flex justify-space-around"
          }, {
            default: _withCtx(() => [
              (_ctx.enableWrite)
                ? (_openBlock(), _createBlock(_component_v_menu, {
                    key: 0,
                    "offset-y": "",
                    "offset-x": ""
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.importCompaniesDialog = !_ctx.importCompaniesDialog)),
                            title: `${_ctx.$t('shared.import')} des dossiers`
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: "$fa-file-import",
                                size: "small"
                              })
                            ]),
                            _: 1
                          }, 8, ["title"]),
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportList())),
                            loading: _ctx.exportLoading,
                            title: `${_ctx.$t('shared.export')} des dossiers`
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: "$fa-file-export",
                                size: "small"
                              })
                            ]),
                            _: 1
                          }, 8, ["loading", "title"]),
                          (_ctx.toCloneCompanies.length)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => {
                                _ctx.initialize();
                                _ctx.companyWizardStep = 1;
                                _ctx.duplicateCompanyDialog = true;
                            }),
                                title: "Ajouter un exemple"
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: "$fa-file-import",
                                    size: "small"
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.accountingFirmClients.length && !_ctx.isArchivedClientCompaniesMode)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "d-flex justify-center",
            style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
          }, [
            _createVNode(_component_v_virtual_scroll, {
              cols: _ctx.$vuetify.display.mobile ? '12' : '8',
              class: "my-0 pa-2",
              items: _ctx.accountingFirmClients
            }, {
              default: _withCtx(({ item: comp }) => [
                _createVNode(_component_v_card, {
                  class: "default_card my-2",
                  elevation: "0",
                  disabled: !_ctx.isAvailableCompany(comp.id)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "d-flex align-center" }, {
                      default: _withCtx(() => [
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "2",
                              onClick: ($event: any) => (
                                    _ctx.isAvailableCompany(comp.id)
                                        ? _ctx.$router.push({ name: 'compa', params: { id: comp.id } })
                                        : ''
                                ),
                              class: "d-flex align-center justify-center",
                              disabled: !_ctx.isAvailableCompany(comp.id)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "$apartment",
                                  color: "green",
                                  size: "x-large"
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          cols: _ctx.$vuetify.display.mobile ? '10' : '8',
                          onClick: ($event: any) => (_ctx.$router.push({ name: 'compa', params: { id: comp.id } }))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                style: {"font-weight":"bold","font-size":"16pt"}
                              }, _toDisplayString(comp.name), 3)
                            ]),
                            _createElementVNode("div", _hoisted_2, [
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : '')
                              }, " SIRET: " + _toDisplayString(_ctx.getSiretValue(comp.siret)), 3)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["cols", "onClick"]),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex justify-space-around align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_tooltip, {
                              location: "bottom",
                              disabled: !_ctx.isAvailableCompany(comp.id)
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_ClientCompaniesEditCompanyBtn, _mergeProps(props, {
                                  company: comp,
                                  disabled: !_ctx.isAvailableCompany(comp.id)
                                }), null, 16, ["company", "disabled"])
                              ]),
                              default: _withCtx(() => [
                                _cache[23] || (_cache[23] = _createElementVNode("span", null, "Modifier", -1))
                              ]),
                              _: 2
                            }, 1032, ["disabled"]),
                            _createVNode(_component_v_tooltip, { location: "bottom" }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn_icon, _mergeProps(props, {
                                  icon: "$oss-duplicate",
                                  color: "green",
                                  elevation: "0",
                                  disabled: !_ctx.isAvailableCompany(comp.id),
                                  onClick: ($event: any) => {
                                                _ctx.companyWizardStep = 2;
                                                _ctx.selectedCompany = comp;
                                                _ctx.newCompanyName = comp.name + ' (copie)';
                                                _ctx.duplicateCompanyDialog = true;
                                            },
                                  "data-cy": 'ClientCompanies-duplicate-' + comp.id,
                                  size: "small"
                                }), null, 16, ["disabled", "onClick", "data-cy"])
                              ]),
                              default: _withCtx(() => [
                                _cache[24] || (_cache[24] = _createElementVNode("span", null, "Dupliquer", -1))
                              ]),
                              _: 2
                            }, 1024),
                            _withDirectives(_createVNode(_component_v_btn_icon, {
                              icon: "$oss-disconnect",
                              color: "red",
                              elevation: "0",
                              disabled: _ctx.disabledArchiveAction(comp.id),
                              onClick: ($event: any) => {
                                        _ctx.selectedCompany = comp;
                                        _ctx.dialogArchiveCompany = true;
                                    },
                              "data-cy": 'ClientCompanies-disconnect-' + comp.id,
                              size: "small"
                            }, null, 8, ["disabled", "onClick", "data-cy"]), [
                              [
                                _directive_tooltip,
                                
                                        _ctx.disabledArchiveAction(comp.id)
                                            ? 'Impossible d\'archiver le dossier racine'
                                            : 'Archiver'
                                    ,
                                void 0,
                                { bottom: true }
                              ]
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["disabled"])
              ]),
              _: 1
            }, 8, ["cols", "items"])
          ], 4))
        : (_ctx.archivedAccountingFirmClients.length && _ctx.isArchivedClientCompaniesMode)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "d-flex justify-center",
              style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
            }, [
              _createVNode(_component_v_virtual_scroll, {
                cols: _ctx.$vuetify.display.mobile ? '12' : '8',
                class: "my-0 pa-2",
                items: _ctx.archivedAccountingFirmClients
              }, {
                default: _withCtx(({ item: archivedAccFirmClient }) => [
                  _createVNode(_component_v_card, {
                    class: "default_card my-2",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "d-flex align-center" }, {
                        default: _withCtx(() => [
                          (!_ctx.$vuetify.display.mobile)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "2",
                                class: "d-flex align-center justify-center",
                                disabled: !_ctx.isAvailableCompany(archivedAccFirmClient.clientId)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: "$apartment",
                                    color: "green",
                                    size: "x-large"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["disabled"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_col, {
                            cols: _ctx.$vuetify.display.mobile ? '10' : '8',
                            disabled: !_ctx.isAvailableCompany(archivedAccFirmClient.clientId)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                  style: {"font-weight":"bold","font-size":"16pt"}
                                }, _toDisplayString(archivedAccFirmClient.name), 3)
                              ]),
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : '')
                                }, " SIRET: " + _toDisplayString(_ctx.getSiretValue(archivedAccFirmClient.siret)), 3)
                              ]),
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : '')
                                }, " Dossier archivé le: " + _toDisplayString(_ctx.getArchivingDate(archivedAccFirmClient.archivingDate)), 3)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["cols", "disabled"]),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "d-flex justify-space-around align-center"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.enableWrite)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    location: "bottom"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_btn_icon, _mergeProps(props, {
                                        icon: "$fa-redo",
                                        color: "red",
                                        elevation: "0",
                                        onClick: ($event: any) => {
                                                _ctx.selectedCompany = archivedAccFirmClient;
                                                _ctx.dialogUnArchiveCompany = true;
                                            },
                                        "data-cy": 
                                                'ClientCompanies-disconnect-' +
                                                archivedAccFirmClient.id
                                            ,
                                        size: "small"
                                      }), null, 16, ["onClick", "data-cy"])
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[25] || (_cache[25] = _createElementVNode("span", null, "Restaurer", -1))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["cols", "items"])
            ], 4))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 2,
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '6',
                  class: "my-0 pa-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "default_card ma-0",
                      elevation: "0",
                      "pa-0": "",
                      style: {"margin":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { class: "d-flex align-center" }, {
                          default: _withCtx(() => [
                            (!_ctx.$vuetify.display.mobile)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "2",
                                  class: "d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      color: "new_red",
                                      class: "icon",
                                      size: "x-large",
                                      icon: "$apartment"
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_col, {
                              cols: _ctx.$vuetify.display.mobile ? '10' : '8'
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                    style: {"font-weight":"bold","font-size":"16pt"}
                                  }, " Aucune société cliente ", 2)
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : '')
                                  }, " Vous n'avez enregistré aucune société cliente ", 2)
                                ])
                              ]),
                              _: 1
                            }, 8, ["cols"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["cols"])
              ]),
              _: 1
            })),
      (_ctx.dialogSelectCompany)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 3,
            modelValue: _ctx.dialogSelectCompany,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialogSelectCompany) = $event)),
            title: 'Choisir une société',
            prefixDataCy: "ClientCompanies-valid",
            width: "1000px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_company_table, {
                accountingFirmId: _ctx.accountingFirm.id,
                showGenericCompany: false,
                showNewCompanies: true,
                showExistingCompanies: false,
                onSelectCompany: _ctx.companySelected,
                wizardMode: true,
                canSelectCompaniesWithAccountingCompany: false,
                "data-cy": "ClientCompanies-company"
              }, null, 8, ["accountingFirmId", "onSelectCompany"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogArchiveCompany,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogArchiveCompany) = $event)),
        "max-width": !_ctx.$vuetify.display.mobile ? '650px' : undefined,
        fullscreen: _ctx.$vuetify.display.mobile,
        "hide-overlay": _ctx.$vuetify.display.mobile,
        title: "Archiver la société cliente",
        "valid-title": "Archiver",
        onValid: _cache[13] || (_cache[13] = ($event: any) => (_ctx.archiveClientCompany(_ctx.selectedCompany, false))),
        prefixDataCy: "ClientCompanies-disconnectValid",
        style: {"overflow-y":"auto"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            dense: "",
            "hide-details": "",
            class: "mx-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _cache[26] || (_cache[26] = _createTextVNode(" Vous êtes sur le point d'archiver la société ")),
                  _createElementVNode("b", null, _toDisplayString(_ctx.selectedCompany.name), 1),
                  _cache[27] || (_cache[27] = _createTextVNode(" de vos sociétés clientes. Souhaitez-vous laisser les accès aux clients ? "))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            dense: "",
            "hide-details": "",
            class: "mx-2 pt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.keepClientUserAccount,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.keepClientUserAccount) = $event)),
                    inline: "",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_radio, _mergeProps(props, {
                            label: "Oui",
                            value: true
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[28] || (_cache[28] = _createElementVNode("span", null, "Passera le client sous la supervision de bobbee", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_radio, _mergeProps(props, {
                            label: "Non",
                            value: false
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[29] || (_cache[29] = _createElementVNode("span", null, "Désactivera le client définitivement", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            dense: "",
            "hide-details": "",
            class: "mx-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => _cache[30] || (_cache[30] = [
                  _createTextVNode(" Confirmer le retrait ? ")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogUnArchiveCompany,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dialogUnArchiveCompany) = $event)),
        "max-width": !_ctx.$vuetify.display.mobile ? '650px' : undefined,
        fullscreen: _ctx.$vuetify.display.mobile,
        "hide-overlay": _ctx.$vuetify.display.mobile,
        title: "Restaurer la société cliente",
        "valid-title": "Restaurer",
        onValid: _cache[15] || (_cache[15] = ($event: any) => (_ctx.unArchiveClientCompany(_ctx.selectedCompany, true))),
        prefixDataCy: "ClientCompanies-disconnectValid"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            dense: "",
            "hide-details": "",
            class: "mx-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _cache[31] || (_cache[31] = _createTextVNode(" Vous êtes sur le point de restaurer la société ")),
                  _createElementVNode("b", null, _toDisplayString(_ctx.selectedCompany.name), 1),
                  _cache[32] || (_cache[32] = _createTextVNode(" de vos sociétés clientes. "))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            dense: "",
            "hide-details": "",
            class: "mx-2 pt-2"
          }),
          _createVNode(_component_v_row, {
            dense: "",
            "hide-details": "",
            class: "mx-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => _cache[33] || (_cache[33] = [
                  _createTextVNode(" Confirmer la restauration ? ")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.duplicateCompanyDialog,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.duplicateCompanyDialog) = $event)),
        "max-width": !_ctx.$vuetify.display.mobile ? '650px' : undefined,
        fullscreen: _ctx.$vuetify.display.mobile,
        "hide-overlay": _ctx.$vuetify.display.mobile,
        title: "Dupliquer la société cliente",
        "valid-title": "Dupliquer",
        onValid: _cache[19] || (_cache[19] = ($event: any) => (_ctx.duplicateCompany())),
        validDisabled: !_ctx.selectedCompany || !_ctx.selectedCompany.id,
        validLoading: _ctx.duplicateCompanyLoading,
        prefixDataCy: "ClientCompanies-duplicateValid"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.companyWizardStep,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.companyWizardStep) = $event)),
            touchless: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    subheader: "",
                    lines: "two"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toCloneCompanies, (company, i) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: i,
                          class: _normalizeClass([_ctx.getCompanyClass(company.id), "oss-list-item-xl"]),
                          onClick: ($event: any) => (_ctx.selectCompanyToClone(company)),
                          "data-cy": 'selectUser-user-' + i
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn_icon, {
                              color: "primary",
                              icon: 
                                        company.id === _ctx.selectedCompany.id
                                            ? '$radio_button_checked'
                                            : '$radio_button_unchecked'
                                    
                            }, null, 8, ["icon"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(company.name), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (company.siret)
                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(company.siret), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick", "data-cy"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "mx-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _cache[34] || (_cache[34] = _createTextVNode(" Vous êtes sur le point de dupliquer la société ")),
                          _createElementVNode("b", null, _toDisplayString(_ctx.selectedCompany.name), 1),
                          _cache[35] || (_cache[35] = _createTextVNode(". Confirmer la duplication ? "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "mx-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.newCompanyName,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newCompanyName) = $event)),
                            label: "Nom de la nouvelle société",
                            "hide-details": "",
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay", "validDisabled", "validLoading"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.newCompanyDialog,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newCompanyDialog) = $event)),
        "max-width": !_ctx.$vuetify.display.mobile ? '100%' : undefined,
        fullscreen: _ctx.$vuetify.display.mobile,
        "hide-overlay": _ctx.$vuetify.display.mobile,
        actions: _ctx.actions,
        title: "Edition | Création de la société",
        prefixDataCy: "ClientCompanies-valid"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_EditCompany, {
              settingsMode: true,
              adminMode: true,
              inCompany: _ctx.newCompany,
              actions: _ctx.actions,
              onUpdated: _ctx.addCompany,
              class: "w-100"
            }, null, 8, ["inCompany", "actions", "onUpdated"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay", "actions"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.importCompaniesDialog,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.importCompaniesDialog) = $event)),
        title: "Importer des dossier",
        "valid-title": "Importer",
        actions: _ctx.importActions,
        width: "60vw"
      }, {
        default: _withCtx(() => [
          (_ctx.importCompaniesDialog)
            ? (_openBlock(), _createBlock(_component_CompaniesImport, {
                key: 0,
                ref: "importComponent",
                actions: _ctx.importActions,
                documentType: 'CLIENT_COMPANIES',
                accountingFirmId: _ctx.accountingFirm.id,
                onDocumentImported: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onDocumentImported()))
              }, null, 8, ["actions", "accountingFirmId"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "actions"])
    ]),
    _: 1
  }))
}